import React from "react"
import { Helmet } from "react-helmet"

const siteUrl = "https://gregwoodwardphoto.com"

const DEFAULT_OG_IMAGE = "https://images.ctfassets.net/jyrf2aeqxxi9/4kpFxk0Ippa2BuA4LsFOq0/9849814cf0f8b867f589a0cd931a1ab7/_DSC7888RLR.jpg?w=1200&h=630&fit=fill&q=80"

export default function SEO({
  title = "Greg Woodward | Photographer & Director",
  description = "Greg Woodward is a photographer and director creating lifestyle, sports and moving-image work for brands and editorial clients.",
  pathname = "/",
  image,
  schema,
}) {
  const canonicalUrl = `${siteUrl}${pathname}`
  const imageUrl =
    image && image.startsWith("http")
      ? image
      : image
        ? `${siteUrl}${image}`
        : DEFAULT_OG_IMAGE

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <script type="application/ld+json">
        {JSON.stringify(
          schema || {
            "@context": "https://schema.org",
            "@type": "Person",
            name: "Greg Woodward",
            jobTitle: "Photographer and Director",
            url: siteUrl,
            sameAs: ["https://www.instagram.com/gregwoodwardphoto/"],
          }
        )}
      </script>
    </Helmet>
  )
}
